import comparePageConfig from '~/assets/config/pages/compare';

export default function (sourceString = '') {
    return sourceString
        .split(comparePageConfig.queryKey.separator)
        .map(item => parseInt(item, 10))
        .filter(item => Number.isInteger(item));
}
